import { useEffect, useState } from 'react';

function useABTest<T>(testId: string): {
  ABVariation: T | '1';
  loading: boolean;
} {
  const [loading, setLoading] = useState(false);
  const [ABVariation, setABVariation] = useState<'1' | T>('1');

  useEffect(() => {
    setLoading(true);

    // @ts-ignore
    window.VWO = window.VWO || [];
    // @ts-ignore
    window._vwo_evq = window._vwo_evq || [];

    // URL is part of an a/b test
    // @ts-ignore
    window.VWO.push([
      'onEventReceive',
      'vA',
      function (vwoData: any) {
        // To fetch A/B test id
        const experimentId = vwoData[1];

        // To fetch A/B test active variation name
        const variationId = vwoData[2];

        if (
          // @ts-ignore
          typeof window._vwo_exp[experimentId].comb_n[variationId] !==
            'undefined' &&
          ['VISUAL_AB', 'VISUAL', 'SPLIT_URL', 'SURVEY'].indexOf(
            // @ts-ignore
            window._vwo_exp[experimentId].type,
          ) > -1
        ) {
          const TEST_ID = testId;

          if (experimentId === TEST_ID) {
            setABVariation(variationId);
          }
        }
      },
    ]);
    setLoading(false);
  }, []);

  return { ABVariation, loading };
}

export default useABTest;
